const UnitList = () => import('Views/unit/unit-list');

export default[
  { path: '/unit-list', component: UnitList },
];



// WEBPACK FOOTER //
// ./src/router/unitEquipment.js